import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'notifications/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('notifications/', '')
      .toLowerCase();
  }
}
